module.exports = __webpack_public_path__ + "assets/img/de-826fd845.png";